export default "__VITE_ASSET__tzQ5jw$7__"